import { Dollar } from 'components/icons'
import { numberToCurrency } from 'helpers/currency'
import type { FC } from 'react'
import type { CardInfoProps } from '.'
import s from './card-info.module.css'

const CardInfo: FC<CardInfoProps> = ({ title, value }) => {
  return (
    <div className={s.root}>
      <div className={s.icon}>
        <Dollar />
      </div>
      <div className={s.content}>
        <div className={s.title}>{title}</div>
        <div className={s.value}>R$ {numberToCurrency(value as unknown as number)}</div>
      </div>
    </div>
  )
}

export default CardInfo
